import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  private defaultMetaDescription: string | null = null;
  private defaultCanonicalUrl: string | null = null;

  constructor(@Inject(DOCUMENT) private doc: Document) {
    // Cache the default meta description on service creation
    const meta = this.doc.querySelector('meta[name="description"]');
    this.defaultMetaDescription = meta ? meta.getAttribute('content') : null;

    const link = this.doc.querySelector('link[rel="canonical"]');
    this.defaultCanonicalUrl = link ? link.getAttribute('href') : null;
  }

  // --- Structured Data ---
  updateStructuredData(data: object) {
    this.removeStructuredData();

    const script = this.doc.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'structured-data'; // Eine ID, um es wiederzufinden
    script.text = JSON.stringify(data);

    this.doc.head.appendChild(script);
  }

  private removeStructuredData() {
    const script = this.doc.getElementById('structured-data');
    if (script) {
      this.doc.head.removeChild(script);
    }
  }

  // --- Meta Description ---
  updateMetaDescription(description: string): void {
    let meta = this.doc.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = this.doc.createElement('meta');
      meta.setAttribute('name', 'description');
      this.doc.head.appendChild(meta);
    }
    meta.setAttribute('content', description);
  }

  resetMetaDescription(): void {
    const meta = this.doc.querySelector('meta[name="description"]');
    if (meta) {
      if (this.defaultMetaDescription) {
        meta.setAttribute('content', this.defaultMetaDescription);
      } else {
        // If there was no default, remove to avoid stale descriptions
        this.doc.head.removeChild(meta);
      }
    }
  }

  updateCanonicalUrl(url: string): void {
    let link = this.doc.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = this.doc.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.doc.head.appendChild(link);
    }
    link.setAttribute('href', url);
  }

  resetCanonicalUrl(): void {
    const link = this.doc.querySelector('link[rel="canonical"]');
    if (link) {
      if (this.defaultCanonicalUrl) {
        link.setAttribute('href', this.defaultCanonicalUrl);
      } else {
        this.doc.head.removeChild(link);
      }
    }
  }
}
